import { service } from '@ember/service';
import Controller from '@ember/controller';
import appointmentWasCreated from 'client-portal/utils/appointment-was-created';

export default class RequestConfirmationController extends Controller {
  @service currentPractice;
  @service session;

  get loggedIn() {
    return this.session.isAuthenticated;
  }

  get appointmentWasCreated() {
    return appointmentWasCreated(this.model?.appointment);
  }

  get useBookAppointmentLanguage() {
    return Boolean(this.currentPractice.get('useBookAppointmentLanguage'));
  }

  get showBookConfirmation() {
    return this.useBookAppointmentLanguage && this.appointmentWasCreated;
  }

  get showDuplicateBookConfirmation() {
    return this.useBookAppointmentLanguage && !this.appointmentWasCreated;
  }

  get professionalWebsiteBookedConfirmation() {
    return Boolean(
      !this.model?.channel?.careCoordinatorMode &&
        this.session.isProfessionalWebsite &&
        this.useBookAppointmentLanguage &&
        this.appointmentWasCreated
    );
  }

  get confirmationMessageKey() {
    if (this.professionalWebsiteBookedConfirmation) {
      return 'confirmation.thankYou.appointmentIsBooked';
    }
    if (this.showBookConfirmation) {
      return 'confirmation.thankYou.appointmentBooked';
    }

    return this.showDuplicateBookConfirmation
      ? 'confirmation.thankYou.checkEmailForNextSteps'
      : 'confirmation.thankYou.appointmentRequested';
  }

  get confirmationSubmessageKey() {
    if (this.professionalWebsiteBookedConfirmation) {
      return 'confirmation.thankYou.appointmentIsBookedSubmessage';
    }
    if (this.showBookConfirmation) {
      return null;
    }

    return this.showDuplicateBookConfirmation
      ? 'confirmation.thankYou.checkEmailForNextStepsSubmessage'
      : 'confirmation.thankYou.appointmentRequestedSubmessage';
  }
}
